import React from "react"
import Img from "gatsby-image"
import cx from "utils/classnames"
import { map } from "lodash-es"
import { FaClock, FaCheck, FaArrowLeft, FaArrowRight } from "react-icons/fa"
import Icon from "entrada-ui/Icon"
import Typography from 'entrada-ui/Typography'
import CardLabel from "components/CardLabel"
import Link from "components/Link"
import {
    useWindowSize,
} from 'utils'
import styles from "./styles.module.scss"

const ListIcon = ({ children }) => (
    <Icon className={styles.listIcon} fontSize="small">
        {children}
    </Icon>
)

const TourCards = ({
    aside,
    showArrows = true,
    children
}) => {
    const wSize = useWindowSize()
    const scrollableRef = React.useRef(null)
    const cardRef = React.useRef(null)

    const [cardSize, setCardSize] = React.useState(0)

    const onClickLeft = ev => {
        scrollableRef.current.scrollLeft = Math.max(
            scrollableRef.current.scrollLeft - cardSize,
            0
        )
    }

    const onClickRight = ev => {
        scrollableRef.current.scrollLeft += cardSize
    }

    React.useEffect(() => {
        if (cardRef) {
            const cardStyle = window.getComputedStyle(cardRef.current)
            const marginRight = cardStyle.getPropertyValue("margin-right")

            setCardSize(cardRef.current.clientWidth + parseInt(marginRight))
        }
    }, [cardRef])

    return (
        <div className={cx(styles.cards, aside && styles.aside)}>
            {showArrows && !aside && (
                <>
                    <button
                        className={cx(styles.btn, styles.btnLeft)}
                        onClick={onClickLeft}
                    >
                        <Icon className={styles.btnIcon}>
                            <FaArrowLeft />
                        </Icon>
                    </button>
                    <button
                        className={cx(styles.btn, styles.btnRight)}
                        onClick={onClickRight}
                    >
                        <Icon className={styles.btnIcon}>
                            <FaArrowRight />
                        </Icon>
                    </button>
                </>
            )}
            <div ref={scrollableRef} className={!aside ? styles.scrollable : undefined}>
                {React.Children.map(children, (child, idx) => (
                    <child.type
                        aside={aside}
                        {...child.props}
                        ref={idx === 0 ? cardRef : undefined}
                    />
                ))}
            </div>
        </div>
    )
}

TourCards.Card = React.forwardRef(function TourCardsCard(props, ref) {
    const {
        className,
        title,
        overview,
        stamp,
        url,
        image,
        departure,
        duration,
        features,
        price,
        combo,
        aside = false,
    } = props

    return (
        <div ref={ref} className={cx(styles.card, className)}>
            <Link to={url} className={styles.imgWrapper}>
                <div className={styles.imageCol}>
                {stamp && <div className={styles.cardStamp}>{stamp}</div>}
                    <Img
                        fluid={{
                            ...image,
                            // aspectRatio: 4 / 3
                        }}
                        className={styles.cardImage}
                    />
                </div>
            </Link>
            <div className={styles.body}>
                <div className={styles.departure}>
                    From {departure}
                </div>
                <div className={styles.headingWrapper}>
                    <div className={styles.cardHeading}>
                        <Typography className={styles.tourTitle} variant="h2" component="h2">
                            <Link className={styles.tourTitleLink} to={url}>{title}</Link>
                        </Typography>
                    </div>
                    {/* <div className={styles.cardHeader}>
                        {departure && (
                            <div className={styles.departure}>
                                From {departure}
                            </div>
                        )}
                        <h3 className={styles.title}>
                            <Link to={url}>{title}</Link>
                        </h3>
                    </div> */}
    
                    {aside && <div className={styles.overview}>{overview}</div>}
    
                    <ul className={styles.list}>
                        <li>
                            {duration && (
                                <>
                                    <ListIcon>
                                        <FaClock className={styles.teal}/>
                                    </ListIcon>
                                    { combo ? 
                                        'Two-day tour combo' : 
                                        `${duration.hours} hours` + (duration.minutes != (null || 0) ? `, ${duration.minutes} minutes` : '')
                                    }
                                </>
                            )}
                        </li>
    
                        {map(features, (feature, idx) => (
                            <li key={idx}>
                                <ListIcon>
                                    <FaCheck className={styles.teal}/>
                                </ListIcon>
                                {feature}
                            </li>
                        ))}
                    </ul>
    
                    <div className={styles.priceSummary}>
                        From <div className={styles.price}>${price} NZD</div>
                    </div>
                </div>
            </div>
        </div>
    )
})

TourCards.CardWp = React.forwardRef(function TourCardsCardWp(props, ref) {
    const {
        url,
        title,
        acf: {
            price,
            card_features,
            card_image,
            card_label_color,
            card_label_text,
            card_overview,
            card_stamp,
            departure,
            tour_duration_hours,
            tour_duration_minutes,
            is_combo
        },
        ...rest
    } = props


    return (
        <TourCards.Card
            {...rest}
            ref={ref}
            title={title}
            overview={card_overview}
            stamp={card_stamp ? card_stamp : false}
            url={url}
            label={{
                title: card_label_text,
                color: card_label_color
            }}
            image={card_image?card_image.localFile.childImageSharp.fluid:undefined}
            departure={departure}
            duration={{
                hours: tour_duration_hours,
                minutes: tour_duration_minutes
            }}
            combo={is_combo}
            features={card_features.map(feature => feature.card_feature)}
            price={price}
        />
    )
})

export default TourCards
